import { isNullOrUndefined } from "../../../../../../tools";
import { IdProvider } from "../../../../../services/idprovider.service";
import { ServerCommunicatorService } from "../../../../../services/server-communicator.service";
import { UIUtils } from "../../../../../services/uiutils.service";
import { Utils } from "../../../../../services/utils.service";
import { DataContainer } from "../../../../infrastructure/datacontainer";
import { DataContainerService } from "../../../../infrastructure/datacontainer.service";
import { RequestTypes } from "../../../../infrastructure/enums";
import { IPersistable } from "../../../../infrastructure/IPersistable";
import { PayloadPacketFacade } from "../../../../infrastructure/payloadpacket/payloadpacketfacade";
import { TransportData } from "../../../../infrastructure/transportdata";
import { ValidationResultAccumulator } from "../../../../infrastructure/validationresultaccumulator";
import { NotificationRecordsFetchRequest } from "./notificationrecordfetchrequest";

export class NotificationRecordsProps {

public id: number = 0;
  public receiver_id: number = 0;
  public sender_id: number = 0;
  public from_entity_id: number = 0;
  public from_entity_type: number = 0;
  public title: string = '';
  public body: string = '';
  public trans_date_time: string = '';
  public is_read: boolean = false;


  public readonly is_newly_created: boolean = false;


  private constructor(IsNewlyCreated: boolean) {
    this.is_newly_created = IsNewlyCreated;
  }

  public static Blank() {
    return new NotificationRecordsProps(true);
  }
}

export class NotificationRecords implements IPersistable<NotificationRecords> {
  public static readonly mastertablename: string = 'notification_records';

  private constructor(public readonly p: NotificationRecordsProps, public readonly AllowEdit: boolean) {

  }

  public async EnsurePrimaryKeysWithValidValues(): Promise<void> {
    if (this.p.id === undefined || this.p.id === 0) {
      const newids = await IdProvider.GetInstance().GetNextEntityId();
      // const newids = await IdProvider.GetInstance().GetAllocateSingleIds();
      this.p.id = newids[0];
      if (this.p.id <= 0) throw new Error("Cannot assign Id. Please try again");

    }

  }

  public GetEditableVersion(): NotificationRecords {
    let newNotificationRecords: NotificationRecordsProps = Utils.GetInstance().DeepCopy(this.p);
    return NotificationRecords.CreateInstance(newNotificationRecords, true);
  }

  public static CreateNewInstance() {
    return new NotificationRecords(NotificationRecordsProps.Blank(), true);
  }

  public static CreateInstance(data: any, allowEdit: boolean) {
    return new NotificationRecords(data as NotificationRecordsProps, allowEdit);
  }

  public CheckSaveValidity(_td: TransportData, vra: ValidationResultAccumulator): void {
    if (!this.AllowEdit) vra.add('', 'This object is not editable and hence cannot be saved.');
    // if (!this.p.Name || this.p.Name.trim() == '') {
    //   vra.add('Name', 'Name cannot be blank. ');
    // }
    // if (this.p.Month == 0) {
    //   vra.add('Month', 'Month cannot be blank. ');
    // }
    // if (this.p.NotificationRecordsRef <= 0) vra.add('NotificationRecordsRef', 'NotificationRecords cannot be blank. ');
    // if (this.p.CityRef <= 0) vra.add('CityRef', 'City cannot be blank. ');
  }

  public MergeIntoTransportData(td: TransportData) {
    DataContainerService.GetInstance().MergeIntoContainer(td.MainData, NotificationRecords.mastertablename, this.p);
  }

  private static m_currentInstance: NotificationRecords = NotificationRecords.CreateNewInstance();

  public static GetCurrentInstance() {
    return NotificationRecords.m_currentInstance;
  }

  public static SetCurrentInstance(value: NotificationRecords) {
    NotificationRecords.m_currentInstance = value;
  }

  // ********************************************
  public static cacheDataChangeLevel: number = -1;

  public static SingleInstanceFromTransportData(td: TransportData): NotificationRecords {
    let dcs = DataContainerService.GetInstance();
    if (dcs.CollectionExists(td.MainData, NotificationRecords.mastertablename)) {
      for (let data of dcs.GetCollection(td.MainData, NotificationRecords.mastertablename)!.Entries) {
        return NotificationRecords.CreateInstance(data, false);
      }
    }

    return null as any;
  }

  public static ListFromDataContainer(cont: DataContainer,
    filterPredicate: (arg0: any) => boolean = null as any,
    sortPropertyName: string = "Name"): NotificationRecords[] {
    let result: NotificationRecords[] = [];

    let dcs = DataContainerService.GetInstance();
    if (dcs.CollectionExists(cont, NotificationRecords.mastertablename)) {
      let coll = dcs.GetCollection(cont, NotificationRecords.mastertablename)!;
      let entries = coll.Entries;

      if (!isNullOrUndefined(filterPredicate)) entries = entries.filter(filterPredicate);

      if (sortPropertyName.trim().length > 0) {
        entries = Utils.OrderByPropertyName(entries, sortPropertyName);
      }

      for (let data of entries) {
        result.push(NotificationRecords.CreateInstance(data, false));
      }
    }

    return result;
  }

  public static ListFromTransportData(td: TransportData): NotificationRecords[] {
    return NotificationRecords.ListFromDataContainer(td.MainData);
  }

  public static async FetchTransportData(req: NotificationRecordsFetchRequest, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let tdRequest = req.FormulateTransportData();
    let pktRequest = PayloadPacketFacade.GetInstance().CreateNewPayloadPacket2(tdRequest);

    let tr = await ServerCommunicatorService.GetInstance().sendHttpRequest(pktRequest);
    if (!tr.Successful) {
      if (!isNullOrUndefined(errorHandler)) await errorHandler(tr.Message);
      return null;
    }

    let tdResponse = JSON.parse(tr.Tag) as TransportData;
    return tdResponse;
  }

  public static async FetchInstance(id: number, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new NotificationRecordsFetchRequest();
    req.employee_record_ids.push(id);

    let tdResponse = await NotificationRecords.FetchTransportData(req, errorHandler) as TransportData;
    return NotificationRecords.SingleInstanceFromTransportData(tdResponse);
  }

  public static async FetchList(req: NotificationRecordsFetchRequest, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let tdResponse = await NotificationRecords.FetchTransportData(req, errorHandler) as TransportData;
    return NotificationRecords.ListFromTransportData(tdResponse);
  }

  public static async FetchEntireList(errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new NotificationRecordsFetchRequest();
    let tdResponse = await NotificationRecords.FetchTransportData(req, errorHandler) as TransportData;
    return NotificationRecords.ListFromTransportData(tdResponse);
  }

  public static async FetchEntireListbyEmployeeRecordRef(employee_record_id: number, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new NotificationRecordsFetchRequest();
    req.employee_record_ids.push(employee_record_id);
    let tdResponse = await NotificationRecords.FetchTransportData(req, errorHandler) as TransportData;
    return NotificationRecords.ListFromTransportData(tdResponse);
  }
  public static async FetchEntireListbyEmployeeRecordRefAndPageNumber(employee_record_ids: number, page_number: number, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new NotificationRecordsFetchRequest();
    req.employee_record_ids.push(employee_record_ids);
    req.page_number = page_number;
    let tdResponse = await NotificationRecords.FetchTransportData(req, errorHandler) as TransportData;
    return NotificationRecords.ListFromTransportData(tdResponse);
  }

  public async DeleteInstance(successHandler: () => Promise<void> = null!, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let tdRequest = new TransportData();
    tdRequest.RequestType = RequestTypes.Deletion;

    this.MergeIntoTransportData(tdRequest);
    let pktRequest = PayloadPacketFacade.GetInstance().CreateNewPayloadPacket2(tdRequest);

    let tr = await ServerCommunicatorService.GetInstance().sendHttpRequest(pktRequest);
    if (!tr.Successful) {
      if (!isNullOrUndefined(errorHandler)) await errorHandler(tr.Message);
    }
    else {
      if (!isNullOrUndefined(successHandler)) await successHandler();
    }
  }

}
